import { Component, OnInit } from '@angular/core';
import { Regulation, AlertItem, AlertType, Contract } from 'src/app/core/models';
import { RegulationService } from 'src/app/core/services/regulation.service';
import { ContractService, ModalService, AlertService } from 'src/app/core/services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-triage-config-modal',
  templateUrl: './triage-config-modal.component.html',
  styleUrls: ['./triage-config-modal.component.sass']
})
export class TriageConfigModalComponent extends BaseModal implements OnInit {
  public regulations: Array<Regulation> = [];
  public selectedRegulationIds = [];
  public form: FormGroup;
  public loading = false;

  constructor(
    private regulationService: RegulationService,
    private contractService: ContractService,
    private formBuilder: FormBuilder,
    public modalService: ModalService,
    private alertService: AlertService
  ) {
    super(modalService);
  }

  async ngOnInit() {
    this.loading = true;
    if (this.initialState == null) {
      this.alertService.show(new AlertItem('GenericError', AlertType.danger));
    }
    const params = this.initialState || {};
    const contractId = params.contractId;
    this.selectedRegulationIds = params.regulationIds;

    await this.contractService.getById(contractId).then(async contract => {
      await this.regulationService.getAll({ regionId: contract.regionId, 'id[in]': `[${contract.regulationIds}]` }).then(regulations => {
        this.regulations = regulations;
      });
    });
    this.createForm(this.selectedRegulationIds);
    this.loading = false;
  }

  createForm(regulationIds = []) {
    this.form = this.formBuilder.group({
      regulationIds: [regulationIds, Validators.required]
    });
  }

  get isValid(): boolean {
    if (this.form != null) {
      return this.form.valid;
    } else {
      return false;
    }
  }

  get lastState(): any {
    return null;
  }

  async onAllSubmited(): Promise<any> {
    this.selectedRegulationIds = this.form.get('regulationIds').value;
  }

}
